import moment from 'moment'
export default {
  methods: {
    valueFromInput(val){
      if (typeof(val) == 'number'){
        return val
      }else{
        if (val == null){
          val = ''
        }
        var v = val.split(",")
        if (v.length == 1){
          return parseFloat(v[0].replace(".", ""))
        }else{
          return parseFloat(v[0].replace(".", "") + '.' + v[1])
        }
      }
    },
    formatNumber(val, fraction = 2) {
      if (Math.abs(val) < 1){
        fraction = 1
      }
      const formatted = new Intl.NumberFormat('de-DE', { maximumFractionDigits: fraction, minimumFractionDigits: fraction }).format(val)

      if (formatted == 'NaN'){
        return '0,00'
      }else {
        return formatted
      }
    },
    input2Float(val){
      if (typeof(val) === 'number'){
        return val
      }else {
        if (val === 'NaN' || val === null){
          return 0
        } else {
          return parseFloat(val.toString().replace(/\./g, '').replace(',', '.'))
        }
      }
    },
    fdate(str){
      return (new Date(str).toLocaleDateString('de', { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' }))
    },
    randomToken(l = 6){
      return Math.random().toString(36).replace(/[^a-z0-9]+/g, '').substr(0, l)
    },
    roundTo50(x){
      var rd = Math.floor(x*2)/2.0
      console.log("Round to 0.5:", x, rd)
      return rd
    },
    sumArr(arr) {
      if(!Array.isArray(arr)) return 0;
      if(!arr.length) return 0;
      return arr.reduce((a, v)=>a + v);
    },
    calculateHoursFromTimespan(timeFrom, timeTo){
      var from = moment(timeFrom, 'HH:mm')
      var to   = moment(timeTo, 'HH:mm')

      if (to < from){
        return moment.duration(to.diff(from)).asHours()+24
      }else{
        return moment.duration(to.diff(from)).asHours()
      }
    }
  },
  computed: {
    isMobileDevice(){
      return window.innerWidth < 480
    },
  }
}



